module.exports = __webpack_public_path__ + "static/media/3.d3dd6edb.jpg";